export const raceDayData = [
  {
    id: "treasure_1",
    name: "THEECA",
    hint: "Walk east from Taylor Square along Burton Street and scan the entryway of the chic corner spot marked by arched glass doors to claim your drink treasure.\n",
    offer:
      "Marathon finishers get their first drink free. Everyone else: Happy Hour prices \u2013 Wine $12, Cocktails/Spritzes $10, Beer $8, Mocktail $10. \nSofts Snacks: Olives, fries, tiramisu, cheese board.",
    address: "1 Burton Street, Darlinghurst NSW 2010",
    hours: "7:30am \u2013 5:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87838566944955,
      longitude: 151.21454047745578,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FTHEECA.png?alt=media&token=61de53d3-5d52-4b56-9445-bd7d57be3729",
  },
  {
    id: "treasure_2",
    name: "The Squire's Landing",
    hint: "Find the bustling harbor spot where ships sail and stories unfold \u2014 seek the T5 building at Circular Quay West, and your prize awaits.\n",
    offer: "10% off food and beverage",
    address: "T5 Circular Quay West, The Rocks, Sydney 2000",
    hours: "12:00pm - Late",
    redeem:
      "Input the unique redemption code when ordering online via 'The Pass' app.",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.8574223615663,
      longitude: 151.21016870831113,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThe%20Squire's%20Landing.png?alt=media&token=d731457a-0db1-4619-9649-62c9cad852ac",
  },
  {
    id: "treasure_3",
    name: "Ventuno",
    hint: "Wood-fired aromas  and the slow swirl of la dolce vita in every bite.",
    offer: "$39 Enjoy one of our wood-fired pizzas and a wine or beer.",
    address: "7/21 Hickson Road, Walsh Bay, Sydney 2000",
    hours: "11:30am - 9:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Choice of wine or beer is limited to selected options determined by the venue. Not valid in conjunction with any other offer. Available only during race week.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85677016955708,
      longitude: 151.20428369079923,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FVentuno.png?alt=media&token=860496cd-fbb4-4713-bf01-d930a9e4c071",
  },
  {
    id: "treasure_4",
    name: "Jacksons on George",
    hint: "Head to 176 George Street, Sydney, where you can grab Asahi pints, schnitzels, and margaritas any time between 10am and midnight.",
    offer: " $15 Asahi pints, $16 Margaritas, $22 Schnitzels, $15 kids meals",
    address: "176 George Street, Sydney",
    hours: "10:00am \u2013 12:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86179600684283,
      longitude: 151.2081247478231,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FJackson-min.png?alt=media&token=881f2af4-01d2-48ea-a0d9-be59db51272a",
  },
  {
    id: "treasure_5",
    name: "The Beacham Hotel",
    hint: "Oxford Street\u2019s triple-decker with rooftop vibes, pool, pinball, cocktails.",
    offer:
      "Selection of 5 main courses for only $15 for lunch and $16.90 for dinner with the purchase of any beverage.",
    address: "265\u2013267 Oxford Street, Darlinghurst",
    hours: "11:00am \u2013 2:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88174433104621,
      longitude: 151.21894643988762,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThe%20Beacham%20Hotel.png?alt=media&token=5c8f4db7-684c-4f9e-b664-a90b44714bba",
  },
  {
    id: "treasure_6",
    name: "Chateau Tanunda Sydney Cellar Door",
    hint: "Old-vine Barossa legends paired with expert pours in a sandstone hideaway. Don't miss the Cellar Door",
    offer:
      "2-for-1 pricing on all tasting offerings at the Sydney Cellar Door.",
    address: "2 Nurses Walk, The Rocks",
    hours: "12:00pm \u2013 6:00pm",
    redeem:
      "Guests can verbally tell the staff on arrival of the code to access the 2 for 1 offer",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85956605309834,
      longitude: 151.20836859677092,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FChateau%20Tanunda%20Sydney%20Cellar%20Door-min.png?alt=media&token=6587fac6-12d8-4097-b76b-622f86747eb9",
  },
  {
    id: "treasure_7",
    name: "XOPP by Golden Century",
    hint: "XOPP, where pipis sizzle and seafood feasts meet Chinatown chic.",
    offer: "10% off",
    address: "Level M, 1 Little Pier Street, Haymarket, NSW 2000",
    hours: "Lunch:  12:00pm \u2013 3:00pm\nDinner:  5:30pm \u2013 10:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.877938939172985,
      longitude: 151.2022114762533,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FXOPP%20by%20Golden%20Century.png?alt=media&token=f397ff21-f530-431f-b71b-b14ede4e297e",
  },
  {
    id: "treasure_8",
    name: "Harajuku Gyoza Beer Stadium",
    hint: "Cheeky dumplings, frosty pints, and Tokyo pop energy in full swing.",
    offer: "$25 \nRice bowl and a drink (tap beer, house wine, or soft drink).",
    address: "1/14 Darling Drive, Sydney 2000",
    hours: "11:30am - 9:00 pm",
    redeem: "Must show code to staff/server to redeem",
    terms: "Code valid only for this specific offer",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87686485911841,
      longitude: 151.20131983322366,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FHarajuku%20Gyoza%20Beer%20Stadium-min.png?alt=media&token=8d40abd1-e18d-43c1-825d-378c91be10f7",
  },
  {
    id: "treasure_9",
    name: "Mecca Coffee",
    hint: "Paddington mornings fuelled by craft roasts and community vibes in Mecca.",
    offer:
      "Buy two coffees, get one free.\nBuy a bag of beans and receive a free coffee.",
    address: "Shop 4, 2\u201316 Glenmore Road, Paddington",
    hours: "7:00am \u2013 4:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: "Limited to coffee only ie: not matcha or chai",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88351572892155,
      longitude: 151.2223730022922,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FMecca%20Coffee-min.png?alt=media&token=061d51c3-3f2d-4bbd-babc-6b0e585955d7",
  },
  {
    id: "treasure_10",
    name: "Kent St Hotel",
    hint: "Kent St on Kent St. CBD classic where beers run cold and banter runs deep.",
    offer:
      "$15 \nCarb-up meal special available exclusively to the Sydney Marathon community!",
    address: "347 Kent Street, Sydney, NSW 2000",
    hours: "10:00am \u2013 12:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86859340448879,
      longitude: 151.2043572436242,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FKent%20St%20Hotel-min.png?alt=media&token=b0ae9abe-b9d8-4b8c-aba8-8f97a285bda6",
  },
  {
    id: "treasure_11",
    name: "ITS RECESS",
    hint: "It\u2019s time for a break! Stacked sambos, crisp edges, and a break worth biting into.",
    offer: "$15 \nBacon & egg toastie + medium coffee combo.",
    address: "1/389 Bourke Street, Surry Hills",
    hours: "7:00am \u2013 3:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.881198586195794,
      longitude: 151.2163291920977,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FITS%20RECESS-min.png?alt=media&token=6b827c7e-83f4-4838-876d-59b4b59c410d",
  },
  {
    id: "treasure_12",
    name: "Paddington Grind",
    hint: "At Shop 2, 339 Oxford Street, Paddington, score deals like buy 2 coffees, get a water free, or a sandwich with a free small coffee.\n\n",
    offer:
      "Buy 2 coffees, get 1 bottle of water free.\nBuy a sandwich, get a small coffee free.",
    address: "Shop 2, 339 Oxford Street, Paddington, NSW 2021",
    hours: "5:15 am - 3:30 pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.885949749551905,
      longitude: 151.22856082970796,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FPaddington%20Grind-min.png?alt=media&token=7a81dea5-29fe-4bcb-ac41-cefa8219ecb8",
  },
  {
    id: "treasure_13",
    name: "The Rawson",
    hint: "Heritage arches, brass bar, wood-fired pizza with harbour views.",
    offer: "$25 \nPizzas all day from 11:00am.",
    address: "100 George Street, The Rocks",
    hours: "From 11:00am",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Available from 11am on the day of the Marathon only. No further discounts.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85815033148831,
      longitude: 151.20941784620732,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThe%20Rawson.png?alt=media&token=f4dadda0-598c-4482-928f-fef125d3f5d5",
  },
  {
    id: "treasure_14",
    name: "Endeavour Tap Rooms",
    hint: "Make your way to 39-43 Argyle Street in The Rocks for a relaxed vibe and freshly brewed craft beers in a historic setting\n",
    offer:
      "Daily $29 meal specials, Happy Hour 4 - 6 pm.\nBuy a tasting paddle, get another free!",
    address: "39\u201343 Argyle Street, The Rocks, NSW 2000",
    hours: "11:30am \u2013 10:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85925815561244,
      longitude: 151.20811402238886,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FEndeavour%20%20Tap%20Rooms-min.png?alt=media&token=49bc8e29-8ecb-493c-bda7-0fe01ad6277a",
  },
  {
    id: "treasure_15",
    name: "The Australian Heritage Hotel",
    hint: "Heritage walls, Aussie fauna pizzas, and over a hundred local brews.",
    offer: "$25 \nPizza & beer deal.",
    address: "100 Cumberland Street, The Rocks, NSW 2000",
    hours: "11:00am \u2013 12:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.859638210732534,
      longitude: 151.2069663794033,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThe%20Australian%20Heritage%20Hotel.png?alt=media&token=7fca18cd-8dd5-4ee5-8c69-394fa1d78a5a",
  },
  {
    id: "treasure_16",
    name: "Barrelhouse Cellars",
    hint: "Spirits flow from the barrel, where craft meets old-world cool in the Cellar.",
    offer: "Free wine and spirit tasting for the Marathon community.",
    address: "73 George Street, The Rocks, Sydney",
    hours: "10:00am \u2013 6:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85856350212335,
      longitude: 151.20890975022243,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FBarrelhouse%20Cellars-min.png?alt=media&token=5f254703-e6fa-4b04-9145-b83ab8245e41",
  },
  {
    id: "treasure_17",
    name: "Black&White Espresso The Rocks",
    hint: "Classic bagels, bold Single O brews amid sandstone charm at Black & White.",
    offer:
      "10% off coffee for marathon runners.\nCoffee & signature Sydney Marathon cookie for only $12.",
    address: "140 George Street, The Rocks, NSW 2000",
    hours: "6:00am \u2013 3:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.859916130844695,
      longitude: 151.20884687771922,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FBlack%26White%20Espresso%20The%20Rocks-min.png?alt=media&token=b3c26b20-34d4-4d3c-afe9-eb717f9eda6d",
  },
  {
    id: "treasure_18",
    name: "Black&White Espresso The Strand",
    hint: "Grab your marathon fuel at George Street\u2019s Black & White The Strand \u2014 coffee\u2019s 10% off and the signature Sydney Marathon Cookie just $12.",
    offer:
      "10% off coffee for marathon runners.\nCoffee & signature Sydney Marathon cookie for only $12.",
    address: "G18/412\u2013414 George Street, Sydney, NSW 2000",
    hours: "8:00am \u2013 5:00pm ",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.869382052795984,
      longitude: 151.2078983814648,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FBlack%26White%20Espresso%20The%20Strand-min.png?alt=media&token=07763935-7cf1-4c20-bf14-e936aead9117",
  },
  {
    id: "treasure_19",
    name: "Wild Sage Barangaroo",
    hint: "Head towards the harbour, where sage advice meets delicious brunch. Look for a cozy spot tucked in at Exchange Place. Perfect for sharing laughs and bottomless sips. You're sure to have a wild time!",
    offer:
      "Celebrate your marathon day with three friends and enjoy a free bottomless upgrade (valued at $20pp), featuring 90 minutes of Aperol Spritz, Bellini, sparkling wine, house red wine, house white wine, and a shared menu of pumpkin hummus, baked halloumi, lobster and lamb tacos, fries, and truffle fries \u2014 now with classic margaritas included, all for only $79pp.",
    address: "Exchange Place, 3 Sussex Street, Barangaroo, 2000",
    hours: "8:00am \u2013 3:00pm",
    redeem:
      "Must show code and finisher medal / proof of participation to staff/server to redeem",
    terms:
      "Minimum of 4 guests (One of which must have ran the Marathon)\n \n House Policy applies to all reservation\n \n Available only from 12PM - 1:30PM\n \n 10% Sunday surcharge",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86503973988588,
      longitude: 151.20283799109626,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FWild%20Sage%20Barangaroo.png?alt=media&token=9c46cfa2-954d-4846-bf84-4fb5e68275b4",
  },
  {
    id: "treasure_20",
    name: "Grandma Moses",
    hint: "Craving comfort like only Grandma can make? Head down Anzac Parade for a bagel that\u2019s schmeared just right. ",
    offer: "$7.95 \nRegular coffee & schmeared bagel.",
    address: "105 Anzac Parade, Kensington",
    hours: "7:00am \u2013 2:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.90927387691168,
      longitude: 151.2231550707909,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FGrandma%20Moses-min.png?alt=media&token=d5dd401d-9acf-40bc-a47b-0bd92d563732",
  },
  {
    id: "treasure_21",
    name: "Kinselas",
    hint: "Feeling thirsty or hungry after your run? Follow the rhythm of Darlinghurst to a historic spot beginning with K, where good times pour all day.  ",
    offer:
      "$15\nPub classics available from midday to 3:00pm (lunch) and 5:00pm to 9:00pm (dinner).",
    address: "383 Bourke Street, Darlinghurst, NSW 2010",
    hours: "From 10:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88094065512487,
      longitude: 151.21649587606277,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FKinselas-min.png?alt=media&token=732b957e-3b48-42d5-8ad4-2bccae386e13",
  },
  {
    id: "treasure_22",
    name: "a'Mare",
    hint: "Treat yourself at Crown Sydney with pasta, wine, and a sweet gelato finish. This elegant Italian spot at Barangaroo is perfect for a Sunday indulgence.",
    offer:
      "Pasta Sundaes menu for $55 per person. Enjoy a glass of wine, a cozy pasta, then finish the meal with one of a'Mare\u2019s iconic house-made gelatos.",
    address: "Crown Sydney, 1 Barangaroo Avenue, Barangaroo",
    hours: "12:00pm \u2013 2:30pm & from 5:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86190632630534,
      longitude: 151.2009304703329,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2Fa'Mare-min.png?alt=media&token=c388aafe-dca8-4e8c-9e16-5000a7c1c095",
  },
  {
    id: "treasure_23",
    name: "NOMAD",
    hint: "Make your way to 16 Foster Street, Surry Hills, for a laid-back dining spot serving Middle Eastern-inspired fare in a stylish warehouse setting.\n",
    offer:
      "Mezze-style lunches at $60pp and $90pp express menu available for lunch and dinner \u2013 dessert on us!",
    address: "16 Foster Street, Surry Hills, NSW 2010",
    hours: "12:00pm \u2013 3:00pm, 5:30pm \u2013 Late",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Bookings preferred, not essential. Bookings can be made from 12:00pm to 2:30pm",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.8798957095395,
      longitude: 151.2103600298687,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FNOMAD-min.png?alt=media&token=cc9226de-81b9-488c-b142-66ac4b08e544",
  },
  {
    id: "treasure_24",
    name: "Quick Brown Fox",
    hint: "The sly one\u2019s hiding in Pyrmont! Catch the Quick Brown Fox on Union Street and enjoy 10% off your post-run fuel.",
    offer:
      "Free small coffee with any food purchase \u2013 dine-in or takeaway!",
    address: "22 Union Street, Pyrmont",
    hours: "7:00am \u2013 3:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: "Max 1 coffee's per person / purchase, includes pastries",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86939920237085,
      longitude: 151.19470938929513,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FQuick%20%20Brown%20Fox.png?alt=media&token=43e67b0e-1e19-415a-b008-8a4c923cbc07",
  },
  {
    id: "treasure_25",
    name: "Dad and the Frog Cafe",
    hint: "Head over to 96 Fitzroy Street, Surry Hills, for a relaxed daytime hangout with a cozy vibe and great sips.\n",
    offer:
      "Long Happy Hour from 11:00am to 2:00pm \u2013 $13 cocktails (until sold out) with food purchase.",
    address: "96 Fitzroy Street, Surry Hills, NSW 2010",
    hours: "7:30am \u2013 3:00pm",
    redeem:
      "Must show code at counter to staff/server when making a purchase to redeem",
    terms: "Only one person can redeem per code",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88558137966711,
      longitude: 151.21692618651386,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FDad%20and%20the%20%20Frog%20Cafe-min.png?alt=media&token=24ae44f4-256f-4bdb-8ccc-e5da6be20b5a",
  },
  {
    id: "treasure_26",
    name: "Industry Beans Castlereagh St.",
    hint: "Fuel your post-race buzz with a cool pick-me-up. Just off Castlereagh, score two Fitzroy Iced Coffees for the price of one \u2014 perfect for sharing or doubling up!\n",
    offer: "Two-for-one Fitzroy Iced Coffees.",
    address: "8 Castlereagh Street, Sydney, NSW 2000",
    hours: "8:00am \u2013 3:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Offer applies to a regular Fitzroy Iced Coffee, takeaway only. Available to redeem once per day per customer.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86652400032291,
      longitude: 151.2101088147506,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FIndustry%20Beans%20Castlereagh%20St.-min.png?alt=media&token=34f8323b-f068-4df3-a9dc-682b5b8fcb1e",
  },
  {
    id: "treasure_27",
    name: "Industry Beans York St.",
    hint: "Need a cool reward near Wynyard? Head to York Street and grab two Fitzroy Iced Coffees for the price of one \u2014 smooth, bold, and twice as nice.",
    offer: "Two-for-one Fitzroy Iced Coffees.",
    address: "38\u201340 York Street, Sydney, NSW 2000",
    hours: "8:00am \u2013 3:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Offer applies to a regular Fitzroy Iced Coffee, takeaway only. Available to redeem once per day per customer.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86931359010019,
      longitude: 151.2062390834864,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FIndustry%20Beans%20York%20St.-min.png?alt=media&token=eabd9a45-ace4-4dde-bdfa-1d9ec67f7fd0",
  },
  {
    id: "treasure_28",
    name: "Hendry\u2019s Coffee",
    hint: "Start your day on Liverpool Street, Darlinghurst, with a fresh brew and enjoy 10% off your coffee fix at Hendry's.",
    offer: "Value Bundle : $15\nAny regular coffee + any toastie.",
    address: "Shop 1, 144\u2013150 Liverpool Street, Darlinghurst 2010",
    hours: "6:30am \u2013 3:00pm (every day)",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87682024646839,
      longitude: 151.2127436785257,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FHendry%E2%80%99s%20Coffee-min.png?alt=media&token=531f720f-9830-4a78-a61f-1559834addd1",
  },
  {
    id: "treasure_29",
    name: "Old Mates Deli",
    hint: "Stop by Oxford Street, Woollahra, and enjoy 15% off at this local deli \u2014 perfect for a tasty grab-and-go.\n",
    offer: "15% off",
    address: "36 Oxford Street, Woollahra, NSW 2025",
    hours: "7:30am \u2013 2:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88893682574869,
      longitude: 151.23269209269466,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FOld%20Mates%20Deli-min.png?alt=media&token=cef1b64b-8b53-4ec6-9355-df9de08f686f",
  },
  {
    id: "treasure_30",
    name: "Joe Bananas",
    hint: "Find stylish shirts, trousers, and jackets on George Street at The Rocks \u2014 enjoy 20% off for the marathon community.",
    offer:
      "20% off on shirts, trousers, and jackets for the TCS Sydney Marathon community.",
    address: "103 George Street, The Rocks",
    hours: "11:00am \u2013 5:00pm",
    redeem:
      "Must show code to staff/server to redeem or enter the code when shopping online",
    terms: "Code valid only for this specific offer",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87224333261458,
      longitude: 151.20652926316046,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FJoe%20Bananas-min.png?alt=media&token=f0a689d2-9799-41b1-af3e-89b962a81604",
  },
  {
    id: "treasure_31",
    name: "Three Blue Ducks Rosebery",
    hint: "Make your way to 1/85 Dunning Avenue, Rosebery, for a fresh and rustic dining experience in a converted warehouse setting.",
    offer:
      "Enjoy a free drink on \u2018The Ducks\u2019 with every meal purchased!",
    address: "1/85 Dunning Avenue, Rosebery, NSW 2018",
    hours: "8:30am \u2013 3:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.916837117123336,
      longitude: 151.2023097836492,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThree%20Blue%20%20Ducks%20Rosebery.png?alt=media&token=ad911c73-349f-426e-ab5d-54fb7637c837",
  },
  {
    id: "treasure_32",
    name: "The Glenmore",
    hint: "Climb up Cumberland Street in The Rocks and look out for the rooftop with harbour views serving marathon-day drink and schnitzel specials! You'll leave wanting more.",
    offer: "$20 schnitzels + $12 pints of 4 Pines Japanese Lager.",
    address: "96 Cumberland Street, The Rocks, NSW 2000",
    hours: "11:00am \u2013 12:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85861522346978,
      longitude: 151.20742867399204,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThe%20Glenmore.png?alt=media&token=6123426a-4ac2-48f1-b2cd-b127a2698b44",
  },
  {
    id: "treasure_65",
    name: "The Rocks Walking Tour",
    hint: "Explore historic Harrington Street and unlock stories of The Rocks Walking Tour, grab $10 off your tour.",
    offer: "Spectator’s Special Discount: $10.00 off per person.",
    address: "28 Harrington Street, The Rocks, Sydney 2000",
    hours:
      "Daily shared public tours are at 10.30am and 1.30pm every day. Available for the whole duration of Event Week, including Event Day",
    redeem:
      "Must show code to staff/server to redeem, or enter the code when booking through the official website: https://www.rockswalkingtours.com.au/",
    terms:
      "Offer is only applicable when purchasing an adult ticket. Offer not available on any other third-party booking platforms.",
    code: "CHEER10",
    coordinates: {
      latitude: -33.859119658821044,
      longitude: 151.20811549611122,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/TREASURE%20HUNT%20IMAGES%2FThe%20Rocks%20%20Walking%20Tours%20(1).jpg?alt=media&token=7d56c165-ca4a-4445-bd9e-55adb8a4c52e",
  },
];
